"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _TextButton = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/TextButton"));
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _Title = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Title"));
var _devicesize = require("@oberoninternal/travelbase-ds/context/devicesize");
var _grid = require("@rebass/grid");
var _dynamic = _interopRequireDefault(require("next/dynamic"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _usePlannerPeriod = _interopRequireDefault(require("../hooks/planner/usePlannerPeriod"));
var _trip = require("../utils/trip");
var _ContentWrapper = _interopRequireDefault(require("./ContentWrapper"));
var _BookButton = _interopRequireDefault(require("./designsystem/BookButton"));
var _Heading = _interopRequireDefault(require("./designsystem/Heading"));
var _UnitDetailsPlannerModal = _interopRequireDefault(require("./UnitDetailsPlannerModal"));
var _UnitStickyBar = require("./UnitStickyBar");
var __jsx = _react.default.createElement;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Planner = (0, _dynamic.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require('./TripPlanner'))), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [require.resolveWeak('./TripPlanner')]
  }
});
const UnitAvailability = ({
  open,
  onClose,
  name,
  id,
  slug,
  booking,
  onBookingChange,
  onBookingReservation,
  reserving,
  maxOccupancy,
  type,
  minOccupancy,
  onOpen,
  petsAllowed,
  firstTripDate,
  loading
}) => {
  const plannerPeriodProps = (0, _usePlannerPeriod.default)((0, _trip.convertToPeriod)(booking.arrivalDate, booking.departureDate));
  const deviceSize = (0, _devicesize.useDeviceSize)();
  const [ref, inView] = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true
  });
  const {
    arrivalDate,
    departureDate,
    trip
  } = booking;
  const bookingIsValid = !!(arrivalDate && departureDate);
  return __jsx(_ContentWrapper.default, {
    ref: ref
  }, __jsx(_grid.Flex, {
    flexDirection: "column",
    width: 1
  }, __jsx("div", {
    className: "gt-m"
  }, __jsx(_Heading.default, null, __jsx(_Title.default, {
    variant: "large"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "G6c/hu",
    defaultMessage: [{
      "type": 0,
      "value": "Beschikbaarheid en prijzen"
    }]
  }))), __jsx(_Body.default, {
    style: {
      marginBottom: '5.6rem'
    }
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "Fl8LZ3",
    defaultMessage: [{
      "type": 0,
      "value": "Selecteer een aankomst- en vertrekdatum"
    }]
  }))), __jsx(_Title.default, {
    className: "lt-m",
    variant: "large"
  }, __jsx(_grid.Box, {
    mb: "2.8rem"
  }, bookingIsValid ? __jsx(_reactIntl.FormattedMessage, {
    id: "tHmTKn",
    defaultMessage: [{
      "type": 0,
      "value": "Reserveren"
    }]
  }) : __jsx(_reactIntl.FormattedMessage, {
    id: "G6c/hu",
    defaultMessage: [{
      "type": 0,
      "value": "Beschikbaarheid en prijzen"
    }]
  }))), !bookingIsValid && __jsx(_Body.default, {
    className: "lt-m",
    style: {
      marginBottom: '5.6rem'
    }
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "Fl8LZ3",
    defaultMessage: [{
      "type": 0,
      "value": "Selecteer een aankomst- en vertrekdatum"
    }]
  })), __jsx(BookingButtonWrapper, null, __jsx(_UnitStickyBar.TripContent, {
    booking: booking,
    plannerIsOpen: open,
    openModal: onOpen,
    loading: loading
  }), __jsx(BookingButton, {
    size: "large",
    submitting: reserving,
    disabled: open && !trip,
    onClick: trip ? onBookingReservation : onOpen,
    "data-cy": "bookingButton"
  }, bookingIsValid && __jsx(_reactIntl.FormattedMessage, {
    id: "tHmTKn",
    defaultMessage: [{
      "type": 0,
      "value": "Reserveren"
    }]
  }), !bookingIsValid && __jsx(_reactIntl.FormattedMessage, {
    id: "G6c/hu",
    defaultMessage: [{
      "type": 0,
      "value": "Beschikbaarheid en prijzen"
    }]
  }))), bookingIsValid && __jsx(_TextButton.default, {
    onClick: onOpen,
    className: "lt-m",
    style: {
      marginTop: '1.6rem',
      width: 'fit-content'
    }
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "9PRlF/",
    defaultMessage: [{
      "type": 0,
      "value": "Aankomst- of vertrekdag wijzigen"
    }]
  })), deviceSize && deviceSize !== 'mobile' && __jsx(InlinePlanner, (0, _extends2.default)({
    modalIsOpen: open,
    slug: slug,
    booking: booking,
    setBooking: onBookingChange,
    maxOccupancy: maxOccupancy,
    minOccupancy: minOccupancy,
    petsAllowed: petsAllowed,
    lazyLoading: !inView,
    reserving: reserving,
    type: type,
    onSubmit: onBookingReservation,
    initialCenterMonth: firstTripDate
  }, plannerPeriodProps))), __jsx(_UnitDetailsPlannerModal.default, (0, _extends2.default)({
    id: id,
    name: name,
    onClose: onClose,
    open: open,
    slug: slug,
    booking: booking,
    setBooking: onBookingChange,
    reserving: reserving,
    onBookingReservation: onBookingReservation,
    minOccupancy: minOccupancy,
    maxOccupancy: maxOccupancy,
    petsAllowed: petsAllowed,
    initialCenterMonth: firstTripDate
  }, plannerPeriodProps)));
};
var _default = exports.default = UnitAvailability;
const InlinePlanner = /*#__PURE__*/(0, _react.memo)(props => __jsx(Planner, props), (prev, next) => {
  // We don't want to rerender two planners at the same time
  if (next.modalIsOpen) {
    return true;
  }
  return Object.keys(next).every(key => Object.is(prev[key], next[key]));
});
const BookingButtonWrapper = (0, _styledComponents.default)(_grid.Flex).withConfig({
  displayName: "UnitAvailability__BookingButtonWrapper",
  componentId: "bbfu72-0"
})(["@media screen and (min-width:", "){display:none;}"], ({
  theme
}) => theme.mediaQueries.s);
const BookingButton = (0, _styledComponents.default)(_BookButton.default).withConfig({
  displayName: "UnitAvailability__BookingButton",
  componentId: "bbfu72-1"
})(["margin-left:auto;flex-grow:1;margin-left:0;"]);